import { getClient } from '@api/client';
import FeatureFlagModule, { FeatureFlagKeys } from '@modules/FeatureFlagModule';
import { graphql } from '@api/generated/gql';
import { ServiceUserUtils } from '@modules/ServiceModule/workspace/lib/serviceUserUtils';

const getCurrentUserStatusQuery = graphql(`
  query currentUserStatus {
    currentUser {
      status
    }
  }
`);

/*
 * New status availabilityActivityStatus is fetched instead of status,
 * availabilityActivityStatus {
 *  availabilityStatus
 *  activityStatus
 *}
 * This change is part of the feature flag
 * featureFeUserStatusPhase2
 */
const getCurrentUserAvailabilityQuery = graphql(`
  query currentUserAvailability {
    currentUser {
      availabilityActivityStatus {
        availabilityStatus
        activityStatus
      }
    }
  }
`);

export const getUserStatusQuery = () => {
  return FeatureFlagModule.isEnabled(FeatureFlagKeys.featureFeUserStatusPhase2)
    ? getCurrentUserAvailabilityQuery
    : getCurrentUserStatusQuery;
};

async function getCurrentUserStatus() {
  const { data, error } = await getClient().query({
    fetchPolicy: 'network-only',
    query: getUserStatusQuery(),
  });

  if (error) {
    throw new Error(error.message);
  }

  return ServiceUserUtils.parseAvailabilityStatus(data.currentUser);
}

export default getCurrentUserStatus;
